import { Injectable } from '@angular/core';
import { FeatureFlagService } from '../services/feature-flag.service';
import { StorageService } from '../services/storage.service';
import { Resolve } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';

@Injectable({
  providedIn: 'root'
})
export class TestDataService implements Resolve<void> {

  constructor(
    private featureToggleService: FeatureFlagService,
    private storageService: StorageService
  ) {}

  resolve(): Observable<void> {
    return this.featureToggleService.getTestBusinesses().pipe(
      tap((result: any) => {
        if (result.data.GetTestBusinesses) {
          this.storageService.setLocalStorageData(
            LOCAL_STORAGE.TEST_BUSINESSES,
            JSON.stringify(result.data.GetTestBusinesses)
          );
        }
      }),
      map(() => undefined)
    );
  }
}
